import createAITextCompletion, { MARK_AI_TEXT_COMPLETION_SELECTION } from './ai_text_completion';
import { StyledAITextCompletionSelection } from 'components/text_editor_new/plugins/ai/components/ai_text_completion_selection';

export default createAITextCompletion;

export { MARK_AI_TEXT_COMPLETION_SELECTION, StyledAITextCompletionSelection };
